module.exports = __webpack_public_path__ + "media/images/review/ico-reviewer-f7aadba46dffb73a921fabe8a44f60da.svg";